import { render, staticRenderFns } from "./editBannedMember.vue?vue&type=template&id=2720fe0e&"
import script from "./editBannedMember.vue?vue&type=script&lang=js&"
export * from "./editBannedMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports